var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M676,431.43c36.22-29,57.07-73.12,57.71-119.53.41-29.26-1.69-66-11.52-97.46-32.42-103.73-124-160-191-172s-136,10-188,45-47,29-136,16-162,25-186,95,49,109.67,57,146.34-6,101.66,133,117.66,181-62,250-40C516.71,440.15,599.43,492.82,676,431.43Z",
    style: {
      fill: "#052455"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676,431.43c36.22-29,57.07-73.12,57.71-119.53.41-29.26-1.69-66-11.52-97.46-32.42-103.73-124-160-191-172s-136,10-188,45-47,29-136,16-162,25-186,95,49,109.67,57,146.34-6,101.66,133,117.66,181-62,250-40C516.71,440.15,599.43,492.82,676,431.43Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.14,78.06c-1.41-1.46-3.86-2.81-8.11-2.92-9.55-.23-7,6.53-9.55,8.16s-3.26-.93-5.83.7-1.4,4.89-3.49,5.36-4.89-2.1-7.46-.47-2.56,3-3.73,3-3.49-.93-4.89,0-3,2.1-3,2.1h25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.77,82.23l-.72-.33a6.3,6.3,0,0,0-.86-2.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.27,94H133s.7-2.1-1.86-3.5-3.73-.23-4.66-1.4,1.85-3.55-2.49-6.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.65,153.11c-1.42-1.47-3.87-2.82-8.12-2.92-9.55-.23-7,6.52-9.55,8.15s-3.26-.93-5.82.7-1.4,4.9-3.5,5.36-4.89-2.1-7.45-.46-2.57,3-3.73,3-3.5-.93-4.89,0-3,2.1-3,2.1h25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.28,157.28l-.73-.33a6.25,6.25,0,0,0-.86-2.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.78,169.06H421.5s.7-2.1-1.86-3.49-3.73-.24-4.66-1.4,1.85-3.55-2.49-6.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.26,49.45c-2.54-2.64-7-5.07-14.62-5.26C580.42,43.77,585,56,580.42,58.89s-5.88-1.68-10.5,1.26-2.52,8.82-6.29,9.66S554.81,66,550.19,69s-4.62,5.46-6.72,5.46-6.3-1.68-8.82,0-5.46,3.78-5.46,3.78h45.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617,57c-.41-.2-.84-.4-1.3-.6a11.39,11.39,0,0,0-1.55-4.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.05,78.21h55.38s1.26-3.78-3.36-6.3-6.71-.42-8.39-2.52c-1.5-1.87,3.33-6.4-4.49-11.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.13,94.06h60.92s2.08-6.23-5.54-10.38-11.07-.69-13.84-4.15,7.62-12.46-13.14-21.45c0,0-1.39-19.38-29.76-20.07-12.24-.3-17.78,3.27-20.74,7.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.54,
    y1: 94.06,
    x2: 269.68,
    y2: 94.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.34,55.38c-.87,2.95-1.81,5.5-3.94,6.85-7.61,4.84-9.68-2.77-17.3,2.08S227,78.84,220.73,80.22,206.19,74,198.58,78.84s-7.61,9-11.07,9-10.38-2.76-14.53,0-9,6.23-9,6.23h77.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrows--inject-5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "658.36 266.99 694.03 194.95 704.74 200.25 702.19 160.44 668.99 182.55 679.7 187.85 644.02 259.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "640.96 157.59 663.44 112.19 670.19 115.53 668.59 90.44 647.66 104.37 654.41 107.71 631.93 153.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Target--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.83,79.5a45.91,45.91,0,1,1-.85,2.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.31,79.31a46.45,46.45,0,1,1-.85,2.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.45,83.89a34.17,34.17,0,1,1-.86,2.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.93,83.69a34.39,34.39,0,1,1-3.08,14.23,34,34,0,0,1,2.22-12.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.27,89.53a.08.08,0,0,1,0,0,17.83,17.83,0,1,1-.93,2.05l0-.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.55,89.71l.21-.42h0a18.6,18.6,0,1,1-2.13,8.63,18.41,18.41,0,0,1,1.2-6.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.57,89.59l-.15,0-.13-.05-.52-.2h0l-14.31-5.4-.52-.2-11.1-4.19-.52-.19-17.88-6.75.88-6.6a.56.56,0,0,0-.33-.59L378.84,59a.57.57,0,0,0-.77.7l2.87,8.5-2.11-.8a1.13,1.13,0,1,0-.8,2.11l2.2.83-6.6,5.07a.56.56,0,0,0-.2.59.55.55,0,0,0,.46.41l15.85,2.44h.08a.57.57,0,0,0,.53-.36l1.49-3.78,17.62,6.65.52.19,11.09,4.18.52.2,14.25,5.38.52.19.42.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.27,89.53h.15l.15,0,10.19,3.85,1.12-3.36a1.12,1.12,0,0,1,1.06-.77h0a1.13,1.13,0,0,1,1.06.8l2,6.62a1.14,1.14,0,0,1-.57,1.34l-5.1,2.54a1.11,1.11,0,0,1-.5.12,1.13,1.13,0,0,1-.74-.27,1.15,1.15,0,0,1-.33-1.21L447,95.58,436.78,91.7a1,1,0,0,1-.38-.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.38,208.46l9,2,2.08-9.12-8.63-2c0-.25,0-.51,0-.77a20.44,20.44,0,0,0-1.64-8.06l7-5.58-5.83-7.31L147.7,183a20.54,20.54,0,0,0-8.13-4.32V170h-9.35v8.38a20.42,20.42,0,0,0-8.49,3.81l-6.77-5.4-5.83,7.31,6.61,5.27a20.48,20.48,0,0,0-2.2,8.93l-8.61,2,2.08,9.12,8.49-1.94a20.77,20.77,0,0,0,5.48,7.1l-4,8.21,8.43,4.06,3.89-8.08a20.31,20.31,0,0,0,8.77.21l4,8.37,8.43-4.06-3.92-8.14A20.72,20.72,0,0,0,152.38,208.46ZM125,198.65a9.18,9.18,0,1,1,9.18,9.18A9.18,9.18,0,0,1,125,198.65Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.13,301.6l6.09,1.39,1.41-6.18-5.85-1.34c0-.17,0-.35,0-.52a14,14,0,0,0-1.1-5.47l4.74-3.78-4-5L695,284.36a13.82,13.82,0,0,0-5.51-2.92v-5.91H683.1v5.67a13.93,13.93,0,0,0-5.75,2.59l-4.59-3.66-4,5,4.48,3.57a13.79,13.79,0,0,0-1.49,6L666,296l1.41,6.18,5.76-1.31a14.11,14.11,0,0,0,3.71,4.81l-2.68,5.56,5.71,2.75,2.64-5.48a13.64,13.64,0,0,0,3.28.41,14.54,14.54,0,0,0,2.66-.26l2.73,5.67,5.72-2.75-2.66-5.51A14.19,14.19,0,0,0,698.13,301.6ZM679.57,295a6.22,6.22,0,1,1,6.22,6.22A6.22,6.22,0,0,1,679.57,295Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.61,163.64l7.38,1.68,1.7-7.48-7.08-1.61c0-.21,0-.42,0-.63A16.77,16.77,0,0,0,170.3,149l5.75-4.58-4.78-6-5.5,4.38a16.91,16.91,0,0,0-6.67-3.54v-7.15h-7.67V139a16.82,16.82,0,0,0-7,3.13l-5.56-4.43-4.78,6,5.42,4.32a16.83,16.83,0,0,0-1.8,7.32l-7.07,1.62,1.71,7.48,7-1.59a17,17,0,0,0,4.49,5.82l-3.25,6.73,6.92,3.33,3.19-6.63a16.81,16.81,0,0,0,4,.49,17.15,17.15,0,0,0,3.22-.31l3.3,6.86,6.92-3.33-3.22-6.67A16.81,16.81,0,0,0,169.61,163.64Zm-22.45-8a7.53,7.53,0,1,1,7.53,7.52A7.53,7.53,0,0,1,147.16,155.6Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M569.75,419.55s-6.21,4-7.45,5-6.95,2.24-6.2,4,7.94,2.73,9.93,2.73,9.67-4,11.66-4.46,2-2.73,1.24-4.47a20.77,20.77,0,0,0-3-4.22l-5.21,1.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.23,418.87s-4.72,5.71-5.46,6.95-5,3.22-5,5.21,7.2,1,9.43.74a9,9,0,0,0,6.45-4.46c1.25-2.49,2.24-7.7.75-9.68S640.23,418.87,640.23,418.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.67,308.93l-.2,1.5-1.54,11.9s-13.8,19.49-18.85,29.64c-2.58,5.18-6.18,11.33-5.68,13.06l15.35,54.52a10,10,0,0,0,3.72,1,10.15,10.15,0,0,0,3.47-.74l-.7-50.46,21.3-23.43,2.73,3.47s7.07,25.08,10.05,29.05S639,419.61,639,419.61a10.69,10.69,0,0,0,4.22,1c2.24,0,3.23-3,3.23-3s-18.49-45.65-19-47.14-.13-38-.13-38l-3-17.62-3.47-11.17s-6.45,1.74-17.37,1.24-21.34-1.24-21.34-1.24Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.38,189.32s-3.47,5.21-4,8.44a8.46,8.46,0,0,0,1.74,6l-2,4.22s6.7,13.65,10.67,19.85,10.42,16.63,14.39,18.62,11.66,10.17,11.66,10.17l4.47-9.68S575.21,230.51,567,219.1a220.5,220.5,0,0,1-13.65-21.59,39.9,39.9,0,0,1,.5-6.45,33.7,33.7,0,0,0,.49-5.71Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.59,243.17s-10.18,12.16-12.16,20.1.49,32.51.49,36-2,7.2.75,9.68,10.92,1.24,13.89,1,17.13,0,21.35-1.25,6.2-3,6.2-5.95-5.21-26.55-6-30.52,2-17.62-1.73-24.08S598.78,240.69,591.59,243.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.85,244.91s-12.41,12.65-14.15,19.35-7.94,19.61-9.92,25.32a116.13,116.13,0,0,1-6,13.15l2.23,8.93,5.71-6.2s5.71-19.61,8.69-27.8,3.47-15.88,4-18.11S589.85,244.91,589.85,244.91Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.59,244.16s-7.45,20.35-7.2,21.84,3.72,56.58,3.72,56.58,3.48,8.44,19.11,7.2S635,326.3,635,326.3s-4.71-18.61-8.93-27.05-6.45-13.4-6.45-17.37-1.74-30.52-2.73-34.74a22.05,22.05,0,0,0-2.24-6.2l-1.48-1.24Z",
    style: {
      fill: "#052455",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.63,286.35l12.16,29.78s-5,2-6.7,3.72a40.09,40.09,0,0,1-3,2.73Z",
    style: {
      fill: "#052455",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.76,204.21s-7.69,6.2-7.69,7.94-2,4.22-2,4.22-4,.5-4.22,2,1.24,4.47,1.24,4.47-2.48,8.44-1.48,10.42,8.18,2.24,8.18,2.24l.25,5.46,17.13-2.73-.25-4.22s9.18-9.93,13.65-14.15-1.24-11.66-6.7-17.37-18.37-5.71-19.36-2.73A3.82,3.82,0,0,0,601.76,204.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.31,213.14a3.42,3.42,0,0,1,3.47.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.57,216.72c-.19.8-.07,1.52.26,1.59s.76-.5.95-1.3.07-1.51-.26-1.59S595.76,215.92,595.57,216.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.88,202.47c-5.46-5.71-18.37-5.71-19.36-2.73a3.82,3.82,0,0,0,1.24,4.47s8.44,1,7.2,3.23-5.46,2.23-4.47,3.72,4.47,4.71,3.23,5.46-2,2.23-1.24,2.73,2-.75,5-.25,2.23,7.44-.5,8.44-4-.25,1,4.22a6.27,6.27,0,0,0,2,1.18c2.48-2.67,9.09-9.71,12.67-13.1C631,215.62,625.34,208.18,619.88,202.47Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "608.96 228.28 604.49 227.29 601.51 229.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "614.17 235.23 591.34 241.43 589.85 246.15 616.9 241.19 614.17 235.23",
    style: {
      fill: "#052455",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.6,196.76l-.75-5.21s2.23-7.19,2.23-8.93-1.73-5.71-1.73-6.7-1.49-2.48-2-.5-1.49,9.43-1.49,9.43-3.22,5.46-3,8.19,2.72,8.44,2.72,8.44l4.47-2.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "559.82 200.74 556.6 196.76 550.64 201.48 554.11 207.44 559.82 200.74",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.92,251.86a18.72,18.72,0,0,0-8.69-9.68,76,76,0,0,0-13.15-5l-33.75-38.46-6.7,6.7s14.15,29.53,16.88,34.49,34.24,39,34.24,39",
    style: {
      fill: "#052455",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.69,414.44s-4.75,6.75-5.75,10.5-.75,8.75,1.75,8.25,8.25-6.75,8.75-8.5,2.25-9.75,2.25-9.75l-6-.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.44,418.69s0,7,1.5,8,11.75,5.25,14.75,5.5,4-.25,2.25-3.75-11.75-10.25-11.75-10.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.94,300.44l-5.75,24.25-3,45.5s-11,19-12,26-4.25,21.25-4.25,21.25,4.5,2,5.25,2,9.75-13,14.75-18,16.25-26.5,16.75-27.5,8.5-32.75,9-33.75,3.5-2.25,3.5-2.25,15.06,21.65,16.88,23.47c2.91,2.91,7.62,10.28,7.62,10.28s10.25,40.75,11,42.75a26.66,26.66,0,0,1,1,5.75l9.25,2s.75-27.25.25-33.75-2.5-20.5-2.5-20.5-15.25-41.75-16-42.75-5.25-11-5.25-11l-1.5-9.5a57.74,57.74,0,0,1-27,1C346.94,302.69,343.94,300.44,343.94,300.44Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.07,232.65a166.54,166.54,0,0,1-16.88,9.79c-7.67,3.67-9.5,7.34-9.5,9.17s-6.67,32.17-6.17,33.83,5,4.17,7.84,4.84,6.83-.17,7.66-.84,3.5-12,3.5-12-1.5,20.5-2.16,23.17,5.5,9.5,11.5,10.67,22.16,1.16,26.33-.17,7-1.67,8.33-4.17,2.17-20.33,2.34-21.5,1.5-11.83,1.5-11.83l4.33,14.67,1.67,3s.83-1.84,6-4.84,6.83-3.33,6.83-3.33-3-9.83-4.83-15.5-3.67-16-6-20.17-6.5-6-12.17-9.5-14-5.5-15-6S363.28,230.7,358.07,232.65Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.52,
    y1: 277.44,
    x2: 348.04,
    y2: 265.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 394.8,
    y1: 262.23,
    x2: 395.4,
    y2: 259.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.36,
    y1: 273.61,
    x2: 394.27,
    y2: 264.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.44 251.94 365.94 256.94 367.94 261.44 362.94 302.94 369.94 309.44 375.44 302.19 370.44 261.94 373.44 256.19 377.43 249.66 370.19 245.44 362.44 251.94",
    style: {
      fill: "#052455",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,230.86s-3.47.91-4.23,3,.3,14.81,1.36,17.53a48.45,48.45,0,0,0,3,5.93s9.28-5.93,10.94-6.23,11.19,4.69,11.19,4.69.3-5.9-3-14.21-11-13-14.36-13.31A5.13,5.13,0,0,0,360,230.86Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.62,229.81s.46,5.29.91,8.91,6.05,15.58,8,17.24,6-3.78,7.41-6.2a27.54,27.54,0,0,1,2-3.17s-9.67-4.69-12.69-10.13-2.73-8-4.09-8.17S358.62,229.81,358.62,229.81Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.5,242.81l7.43,12s3.42-3.16,4-5S363.5,242.81,363.5,242.81Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.71,221.32a12.2,12.2,0,0,0-.71,5.43c.23,3.31,2.12,5.67,3.07,5.9a13.8,13.8,0,0,0,2.6.24s.23,5.9,2.83,9.92,11.34,9.68,13.93,6.85,5.91-14.17,7.09-19.6a98.94,98.94,0,0,0,1.65-10.63l-17.47-4-8.27-1.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.86,219s.95,3.07-.94,5-2.6,1.89-2.6,1.89.47,3.07-.24,3.07a2.32,2.32,0,0,1-2.36-2.37,6.9,6.9,0,0,0-1.18-3.54l-2.83-1.65a23.91,23.91,0,0,1,.23-10.39c1.42-5.43,11.57-7.56,20.08-7.32s10.62,11.1,10.62,11.1a40.55,40.55,0,0,1,5.2,2.83c.71.71,1.42,2.36-2.6,4.49s-11.1,2.83-15.35,1.18A44.81,44.81,0,0,1,365.86,219Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.59,231.56c-.28.88-.85,1.48-1.29,1.35s-.57-1-.3-1.84.85-1.48,1.28-1.34S371.86,230.69,371.59,231.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.41,232.32c-.27.88-.85,1.48-1.28,1.34s-.58-1-.31-1.83.85-1.48,1.29-1.35S381.68,231.44,381.41,232.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,228.6s1.52-2.27,5-1.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.73,228.29a3.08,3.08,0,0,1,4.53.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,239.18a15,15,0,0,0-4.23.75c-2.27.76-5.59-.15-4.08,1.82s4.38,2.57,7.4,2.57,5.75-.15,6.66-1.51,2.26-2.72,1.21-2.88-5.14-.45-5.6-.45A6.32,6.32,0,0,1,374,239.18Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,230.41s-.3,8.31-.6,9.83a2,2,0,0,1-3.63.9,20.69,20.69,0,0,1-2.42-4.08",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.19,279.44s-7.2,1.18-10.2,3.18-4.05,3.74-3.3,5.66a28.49,28.49,0,0,0,2.5,5.41c1.25,2,3.5.5,3.5.5a2.21,2.21,0,0,1,.25-3.25c1.75-1.75,8.25-4.25,8.25-4.25h2.25c1,0,0-2.75-.75-4S411.94,278.94,410.19,279.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.44,291.44s0,7.25.5,14.5,6.5,27.5,6.5,27.5l6-1.5s-.25-19-.25-25-.25-13.25-.25-13.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.35,286.39a1.81,1.81,0,0,1,2.86-1.25,12.94,12.94,0,0,0,5.48,2.05,25.25,25.25,0,0,0,7.25.23,1.46,1.46,0,0,1,1.59,1.87c-.63,2.07-1.58,4.89-2.34,5.65-1.25,1.25-7.25,1.25-10.25.25s-3.75-1.75-4.5-4.25A13,13,0,0,1,324.35,286.39Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.94,310.94a10.94,10.94,0,0,1,3-4.75c2.25-2,3.25-2.5,1-2.75s-5,3.25-5,3.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.69,294.19a19.27,19.27,0,0,0,5.25,3.75c3.75,2,22.5,12.25,22.5,12.25l6.75-4s-10.5-4.75-15.25-9.75-8.5-9.75-8.5-9.75S400.94,287.44,402.69,294.19Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.19,307.44s1,5.25,2.75,5.5,10.25-.5,11-2,1.25-6.75,0-7S427.19,307.44,427.19,307.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.2,339.52a11,11,0,0,0-4.49-3.39c-2.81-1.07-3.92-1.19-1.9-2.22s5.82,1.28,5.82,1.28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.82,331.39s.92,5.26-.63,6.11-9.76,3.15-11,2-3.56-5.88-2.47-6.55S344.82,331.39,344.82,331.39Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92,370.9s.87-3.15.89-3.35c.34-2.39-.42-7.19-2.85-8.37a3.2,3.2,0,0,0-4.35,1.93c-.65,1.79.18,4,1.15,5.49C88,368.38,92,370.9,92,370.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.14,369.86c1.94.85,6.67.74,6.68.74s-1-3.1-1.11-3.29c-1-2.17-4.33-5.76-7-5.4a3.19,3.19,0,0,0-2.56,4C40.59,367.76,42.49,369.14,44.14,369.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.78,383.58c2,.29,6.23-.93,6.57-1a55.44,55.44,0,0,0,2.56,7.09c.58,1.35,1.21,2.68,1.85,4-.38-.57-.73-1.07-.79-1.14-1.57-1.82-5.69-4.41-8.17-3.36a3.2,3.2,0,0,0-1.42,4.54c.92,1.67,3.12,2.49,4.9,2.75s5.43-.71,6.38-1c.26.51.5,1,.76,1.53,1.22,2.44,2.46,4.87,3.59,7.28.4.85.76,1.71,1.13,2.56-.34-.5-.64-.92-.69-1-1.57-1.82-5.69-4.42-8.17-3.36A3.2,3.2,0,0,0,52.86,407c.92,1.66,3.12,2.49,4.9,2.75s5.07-.62,6.21-.93c.35.88.7,1.77,1,2.64.19.6.41,1.17.57,1.78s.34,1.2.5,1.79c.28,1.16.57,2.34.81,3.48.18.78.33,1.53.48,2.29-.39-.85-1.18-2.5-1.26-2.63-1.29-2-5-5.23-7.58-4.57a3.19,3.19,0,0,0-2.08,4.27c.65,1.79,2.7,2.94,4.42,3.47,1.89.58,6.09.05,6.61,0,.25,1.25.48,2.47.69,3.63.42,2.41.75,4.59,1,6.45h1.76c-.3-1.93-.69-4.21-1.19-6.75-.25-1.27-.55-2.63-.86-4a34.34,34.34,0,0,0,3.69-1.74c1.38,1.5,4.92,3.25,5.38,3.47-.48,1.18-1,2.33-1.43,3.41-.92,2.11-1.8,4-2.58,5.62h1.9c.67-1.48,1.4-3.16,2.15-5,.49-1.2,1-2.5,1.5-3.83.51.11,4.66.95,6.6.51,1.75-.39,3.88-1.38,4.67-3.12A3.19,3.19,0,0,0,89,415.59c-2.55-.86-6.46,2-7.89,4-.08.12-.86,1.46-1.34,2.31.21-.54.41-1.07.61-1.63.41-1.12.79-2.24,1.19-3.44l.54-1.79c.19-.59.31-1.24.48-1.87.35-1.46.63-3,.88-4.47,1,.35,4.45,1.57,6.26,1.44s4-.79,5.08-2.38a3.19,3.19,0,0,0-1.07-4.63c-2.4-1.24-6.7,1-8.4,2.74-.11.11-1.2,1.46-1.78,2.22.14-.91.29-1.82.4-2.75.33-2.67.59-5.39.85-8.1.08-.83.17-1.66.26-2.48.34.13,4.45,1.65,6.47,1.51,1.8-.12,4.05-.78,5.09-2.38a3.19,3.19,0,0,0-1.08-4.63c-2.39-1.24-6.69,1-8.4,2.74-.13.13-1.69,2.09-2.07,2.6.2-1.82.41-3.63.68-5.41A58.8,58.8,0,0,1,87.27,382c.16.06,4.44,1.68,6.51,1.53,1.79-.12,4-.78,5.08-2.38a3.19,3.19,0,0,0-1.07-4.63c-2.4-1.24-6.69,1-8.4,2.74-.11.12-1.31,1.6-1.86,2.32l-.13-.07a40.44,40.44,0,0,1,2.83-6.76c.61-1.2,1.26-2.32,1.92-3.39.77.39,4.29,2.1,6.17,2.17s4.1-.33,5.31-1.81a3.19,3.19,0,0,0-.56-4.72c-2.24-1.49-6.77.31-8.65,1.81-.1.08-1,1-1.73,1.72.3-.48.61-1,.91-1.43,1.13-1.7,2.27-3.18,3.29-4.49.58-.74,1.12-1.4,1.64-2,1,0,4.77-.13,6.43-.91s3.5-2.2,3.89-4.06a3.19,3.19,0,0,0-2.67-3.93c-2.68-.29-5.87,3.39-6.85,5.59-.09.19-1.07,3.32-1,3.32h.06c-.51.58-1.05,1.2-1.62,1.9-1,1.29-2.22,2.75-3.39,4.44a53.58,53.58,0,0,0-3.52,5.6,42.26,42.26,0,0,0-3,6.77s0,0,0,.08c0-.79,0-3,0-3.17-.3-2.39-2.31-6.82-5-7.31a3.18,3.18,0,0,0-3.68,3c-.16,1.9,1.22,3.8,2.56,5,1.51,1.35,5.71,2.66,6,2.76A56.84,56.84,0,0,0,85,389c-.25,1.44-.47,2.91-.66,4.37,0-.68,0-1.29,0-1.38-.31-2.38-2.31-6.82-5-7.31a3.19,3.19,0,0,0-3.68,3c-.15,1.9,1.22,3.8,2.56,5s4.93,2.4,5.87,2.71l-.21,1.69c-.32,2.71-.63,5.41-1,8.05-.14.93-.31,1.84-.47,2.76,0-.61,0-1.12,0-1.2-.31-2.39-2.31-6.82-5-7.31a3.18,3.18,0,0,0-3.68,3c-.16,1.9,1.22,3.8,2.56,5s4.58,2.28,5.7,2.65c-.2.93-.39,1.86-.62,2.75-.18.61-.3,1.2-.51,1.8l-.57,1.78c-.41,1.11-.82,2.26-1.24,3.34-.29.75-.58,1.46-.87,2.18.15-.93.4-2.75.4-2.9a12.37,12.37,0,0,0-1.66-6,4.24,4.24,0,0,0,0-.71,3.19,3.19,0,0,0-3.9-2.71c-2.61.7-4.26,5.28-4.39,7.68,0,.14.09,1.69.17,2.67-.14-.57-.26-1.12-.4-1.7-.27-1.16-.58-2.3-.9-3.53l-.54-1.78c-.17-.6-.43-1.22-.63-1.83-.52-1.41-1.11-2.81-1.74-4.21,1-.24,4.58-1.15,6-2.26s2.94-2.88,2.92-4.79A3.19,3.19,0,0,0,70,396.55c-2.69.29-5,4.57-5.5,6.93,0,.14-.19,1.88-.26,2.83-.38-.84-.76-1.68-1.18-2.51-1.2-2.42-2.48-4.83-3.76-7.23-.39-.74-.77-1.48-1.15-2.22.36-.08,4.62-1.07,6.23-2.3,1.43-1.1,2.94-2.89,2.93-4.79A3.19,3.19,0,0,0,63.82,384c-2.68.29-5,4.56-5.5,6.92,0,.18-.26,2.67-.28,3.31-.85-1.63-1.68-3.26-2.43-4.89A57.09,57.09,0,0,1,53,382.52c.17,0,4.63-1,6.27-2.31,1.43-1.1,2.94-2.89,2.93-4.79a3.19,3.19,0,0,0-3.45-3.27c-2.68.29-5,4.56-5.49,6.92,0,.16-.21,2.06-.27,3l-.15,0a41,41,0,0,1-1.38-7.21c-.15-1.34-.22-2.63-.25-3.88.85-.11,4.72-.62,6.33-1.59s3.24-2.55,3.44-4.45a3.19,3.19,0,0,0-3.07-3.62c-2.7,0-5.48,4-6.23,6.27,0,.13-.31,1.44-.49,2.4,0-.57,0-1.15,0-1.7,0-2,.14-3.9.26-5.56.08-.94.18-1.79.27-2.58.78-.53,3.9-2.74,4.86-4.31s1.7-3.76,1-5.53a3.18,3.18,0,0,0-4.39-1.8c-2.4,1.24-3,6.06-2.63,8.44,0,.2.94,3.35,1,3.33l0,0c-.11.76-.21,1.58-.31,2.48-.16,1.65-.33,3.52-.38,5.57a53.39,53.39,0,0,0,.16,6.61,40.71,40.71,0,0,0,1.22,7.31l0,.08c-.43-.67-1.68-2.49-1.79-2.62-1.57-1.82-5.69-4.42-8.17-3.36a3.19,3.19,0,0,0-1.42,4.53C41.8,382.49,44,383.32,45.78,383.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.14,369.86c1.94.85,6.67.74,6.68.74s-1-3.1-1.11-3.29c-1-2.17-4.33-5.76-7-5.4a3.19,3.19,0,0,0-2.56,4C40.59,367.76,42.49,369.14,44.14,369.86Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,370.9s.87-3.15.89-3.35c.34-2.39-.42-7.19-2.85-8.37a3.2,3.2,0,0,0-4.35,1.93c-.65,1.79.18,4,1.15,5.49C88,368.38,92,370.9,92,370.9Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.78,383.58c2,.29,6.23-.93,6.57-1a55.44,55.44,0,0,0,2.56,7.09c.58,1.35,1.21,2.68,1.85,4-.38-.57-.73-1.07-.79-1.14-1.57-1.82-5.69-4.41-8.17-3.36a3.2,3.2,0,0,0-1.42,4.54c.92,1.67,3.12,2.49,4.9,2.75s5.43-.71,6.38-1c.26.51.5,1,.76,1.53,1.22,2.44,2.46,4.87,3.59,7.28.4.85.76,1.71,1.13,2.56-.34-.5-.64-.92-.69-1-1.57-1.82-5.69-4.42-8.17-3.36A3.2,3.2,0,0,0,52.86,407c.92,1.66,3.12,2.49,4.9,2.75s5.07-.62,6.21-.93c.35.88.7,1.77,1,2.64.19.6.41,1.17.57,1.78s.34,1.2.5,1.79c.28,1.16.57,2.34.81,3.48.18.78.33,1.53.48,2.29-.39-.85-1.18-2.5-1.26-2.63-1.29-2-5-5.23-7.58-4.57a3.19,3.19,0,0,0-2.08,4.27c.65,1.79,2.7,2.94,4.42,3.47,1.89.58,6.09.05,6.61,0,.25,1.25.48,2.47.69,3.63.42,2.41.75,4.59,1,6.45h1.76c-.3-1.93-.69-4.21-1.19-6.75-.25-1.27-.55-2.63-.86-4a34.34,34.34,0,0,0,3.69-1.74c1.38,1.5,4.92,3.25,5.38,3.47-.48,1.18-1,2.33-1.43,3.41-.92,2.11-1.8,4-2.58,5.62h1.9c.67-1.48,1.4-3.16,2.15-5,.49-1.2,1-2.5,1.5-3.83.51.11,4.66.95,6.6.51,1.75-.39,3.88-1.38,4.67-3.12A3.19,3.19,0,0,0,89,415.59c-2.55-.86-6.46,2-7.89,4-.08.12-.86,1.46-1.34,2.31.21-.54.41-1.07.61-1.63.41-1.12.79-2.24,1.19-3.44l.54-1.79c.19-.59.31-1.24.48-1.87.35-1.46.63-3,.88-4.47,1,.35,4.45,1.57,6.26,1.44s4-.79,5.08-2.38a3.19,3.19,0,0,0-1.07-4.63c-2.4-1.24-6.7,1-8.4,2.74-.11.11-1.2,1.46-1.78,2.22.14-.91.29-1.82.4-2.75.33-2.67.59-5.39.85-8.1.08-.83.17-1.66.26-2.48.34.13,4.45,1.65,6.47,1.51,1.8-.12,4.05-.78,5.09-2.38a3.19,3.19,0,0,0-1.08-4.63c-2.39-1.24-6.69,1-8.4,2.74-.13.13-1.69,2.09-2.07,2.6.2-1.82.41-3.63.68-5.41A58.8,58.8,0,0,1,87.27,382c.16.06,4.44,1.68,6.51,1.53,1.79-.12,4-.78,5.08-2.38a3.19,3.19,0,0,0-1.07-4.63c-2.4-1.24-6.69,1-8.4,2.74-.11.12-1.31,1.6-1.86,2.32l-.13-.07a40.44,40.44,0,0,1,2.83-6.76c.61-1.2,1.26-2.32,1.92-3.39.77.39,4.29,2.1,6.17,2.17s4.1-.33,5.31-1.81a3.19,3.19,0,0,0-.56-4.72c-2.24-1.49-6.77.31-8.65,1.81-.1.08-1,1-1.73,1.72.3-.48.61-1,.91-1.43,1.13-1.7,2.27-3.18,3.29-4.49.58-.74,1.12-1.4,1.64-2,1,0,4.77-.13,6.43-.91s3.5-2.2,3.89-4.06a3.19,3.19,0,0,0-2.67-3.93c-2.68-.29-5.87,3.39-6.85,5.59-.09.19-1.07,3.32-1,3.32h.06c-.51.58-1.05,1.2-1.62,1.9-1,1.29-2.22,2.75-3.39,4.44a53.58,53.58,0,0,0-3.52,5.6,42.26,42.26,0,0,0-3,6.77s0,0,0,.08c0-.79,0-3,0-3.17-.3-2.39-2.31-6.82-5-7.31a3.18,3.18,0,0,0-3.68,3c-.16,1.9,1.22,3.8,2.56,5,1.51,1.35,5.71,2.66,6,2.76A56.84,56.84,0,0,0,85,389c-.25,1.44-.47,2.91-.66,4.37,0-.68,0-1.29,0-1.38-.31-2.38-2.31-6.82-5-7.31a3.19,3.19,0,0,0-3.68,3c-.15,1.9,1.22,3.8,2.56,5s4.93,2.4,5.87,2.71l-.21,1.69c-.32,2.71-.63,5.41-1,8.05-.14.93-.31,1.84-.47,2.76,0-.61,0-1.12,0-1.2-.31-2.39-2.31-6.82-5-7.31a3.18,3.18,0,0,0-3.68,3c-.16,1.9,1.22,3.8,2.56,5s4.58,2.28,5.7,2.65c-.2.93-.39,1.86-.62,2.75-.18.61-.3,1.2-.51,1.8l-.57,1.78c-.41,1.11-.82,2.26-1.24,3.34-.29.75-.58,1.46-.87,2.18.15-.93.4-2.75.4-2.9a12.37,12.37,0,0,0-1.66-6,4.24,4.24,0,0,0,0-.71,3.19,3.19,0,0,0-3.9-2.71c-2.61.7-4.26,5.28-4.39,7.68,0,.14.09,1.69.17,2.67-.14-.57-.26-1.12-.4-1.7-.27-1.16-.58-2.3-.9-3.53l-.54-1.78c-.17-.6-.43-1.22-.63-1.83-.52-1.41-1.11-2.81-1.74-4.21,1-.24,4.58-1.15,6-2.26s2.94-2.88,2.92-4.79A3.19,3.19,0,0,0,70,396.55c-2.69.29-5,4.57-5.5,6.93,0,.14-.19,1.88-.26,2.83-.38-.84-.76-1.68-1.18-2.51-1.2-2.42-2.48-4.83-3.76-7.23-.39-.74-.77-1.48-1.15-2.22.36-.08,4.62-1.07,6.23-2.3,1.43-1.1,2.94-2.89,2.93-4.79A3.19,3.19,0,0,0,63.82,384c-2.68.29-5,4.56-5.5,6.92,0,.18-.26,2.67-.28,3.31-.85-1.63-1.68-3.26-2.43-4.89A57.09,57.09,0,0,1,53,382.52c.17,0,4.63-1,6.27-2.31,1.43-1.1,2.94-2.89,2.93-4.79a3.19,3.19,0,0,0-3.45-3.27c-2.68.29-5,4.56-5.49,6.92,0,.16-.21,2.06-.27,3l-.15,0a41,41,0,0,1-1.38-7.21c-.15-1.34-.22-2.63-.25-3.88.85-.11,4.72-.62,6.33-1.59s3.24-2.55,3.44-4.45a3.19,3.19,0,0,0-3.07-3.62c-2.7,0-5.48,4-6.23,6.27,0,.13-.31,1.44-.49,2.4,0-.57,0-1.15,0-1.7,0-2,.14-3.9.26-5.56.08-.94.18-1.79.27-2.58.78-.53,3.9-2.74,4.86-4.31s1.7-3.76,1-5.53a3.18,3.18,0,0,0-4.39-1.8c-2.4,1.24-3,6.06-2.63,8.44,0,.2.94,3.35,1,3.33l0,0c-.11.76-.21,1.58-.31,2.48-.16,1.65-.33,3.52-.38,5.57a53.39,53.39,0,0,0,.16,6.61,40.71,40.71,0,0,0,1.22,7.31l0,.08c-.43-.67-1.68-2.49-1.79-2.62-1.57-1.82-5.69-4.42-8.17-3.36a3.19,3.19,0,0,0-1.42,4.53C41.8,382.49,44,383.32,45.78,383.58Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.32,370.9s.86-3.15.89-3.35c.33-2.39-.43-7.19-2.86-8.37a3.2,3.2,0,0,0-4.35,1.93c-.65,1.79.18,4,1.16,5.49C695.3,368.38,699.31,370.9,699.32,370.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.41,369.86c1.94.85,6.67.74,6.68.74s-1-3.1-1.11-3.29c-1-2.17-4.32-5.76-7-5.4a3.19,3.19,0,0,0-2.56,4C647.86,367.76,649.76,369.14,651.41,369.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.05,383.58c2,.29,6.23-.93,6.57-1a57,57,0,0,0,2.56,7.09c.58,1.35,1.21,2.68,1.86,4l-.79-1.14c-1.58-1.82-5.7-4.41-8.18-3.36a3.21,3.21,0,0,0-1.42,4.54c.92,1.67,3.12,2.49,4.9,2.75s5.43-.71,6.39-1l.75,1.53c1.22,2.44,2.46,4.87,3.59,7.28.4.85.77,1.71,1.13,2.56-.34-.5-.63-.92-.68-1-1.58-1.82-5.7-4.42-8.18-3.36a3.2,3.2,0,0,0-1.42,4.54c.92,1.66,3.12,2.49,4.9,2.75s5.08-.62,6.21-.93c.35.88.7,1.77,1,2.64.19.6.42,1.17.57,1.78s.34,1.2.5,1.79c.28,1.16.57,2.34.81,3.48.18.78.33,1.53.48,2.29-.38-.85-1.18-2.5-1.26-2.63-1.28-2-5-5.23-7.58-4.57a3.19,3.19,0,0,0-2.08,4.27c.65,1.79,2.7,2.94,4.42,3.47,1.89.58,6.09.05,6.61,0,.25,1.25.49,2.47.69,3.63.42,2.41.75,4.59,1,6.45h1.76c-.3-1.93-.69-4.21-1.19-6.75-.25-1.27-.54-2.63-.86-4a34.34,34.34,0,0,0,3.69-1.74c1.38,1.5,4.92,3.25,5.38,3.47-.48,1.18-1,2.33-1.43,3.41-.92,2.11-1.79,4-2.58,5.62h1.91c.66-1.48,1.39-3.16,2.14-5,.5-1.2,1-2.5,1.5-3.83.51.11,4.66.95,6.6.51,1.76-.39,3.88-1.38,4.67-3.12a3.19,3.19,0,0,0-1.77-4.41c-2.55-.86-6.46,2-7.89,4-.08.12-.86,1.46-1.34,2.31.21-.54.41-1.07.61-1.63.41-1.12.79-2.24,1.19-3.44l.54-1.79c.19-.59.32-1.24.48-1.87.35-1.46.63-3,.88-4.47,1,.35,4.46,1.57,6.26,1.44s4-.79,5.08-2.38a3.19,3.19,0,0,0-1.07-4.63c-2.4-1.24-6.7,1-8.4,2.74-.11.11-1.2,1.46-1.78,2.22.14-.91.29-1.82.4-2.75.34-2.67.59-5.39.85-8.1.08-.83.17-1.66.26-2.48.35.13,4.45,1.65,6.47,1.51,1.8-.12,4-.78,5.09-2.38a3.2,3.2,0,0,0-1.07-4.63c-2.4-1.24-6.7,1-8.41,2.74-.13.13-1.69,2.09-2.06,2.6.19-1.82.4-3.63.68-5.41a57,57,0,0,1,1.55-7.13c.16.06,4.44,1.68,6.51,1.53,1.8-.12,4.05-.78,5.09-2.38a3.2,3.2,0,0,0-1.08-4.63c-2.39-1.24-6.69,1-8.4,2.74-.11.12-1.31,1.6-1.86,2.32l-.13-.07a40.44,40.44,0,0,1,2.83-6.76c.61-1.2,1.26-2.32,1.92-3.39.77.39,4.29,2.1,6.17,2.17s4.11-.33,5.31-1.81a3.19,3.19,0,0,0-.55-4.72c-2.25-1.49-6.77.31-8.66,1.81-.1.08-1.05,1-1.73,1.72.3-.48.61-1,.91-1.43,1.13-1.7,2.27-3.18,3.29-4.49.58-.74,1.13-1.4,1.64-2,1,0,4.77-.13,6.44-.91s3.49-2.2,3.88-4.06a3.19,3.19,0,0,0-2.67-3.93c-2.68-.29-5.87,3.39-6.85,5.59-.08.19-1.07,3.32-1,3.32h.06c-.51.58-1,1.2-1.62,1.9-1,1.29-2.22,2.75-3.39,4.44a55.29,55.29,0,0,0-3.52,5.6,42.26,42.26,0,0,0-3,6.77s0,0,0,.08c0-.79,0-3,0-3.17-.31-2.39-2.32-6.82-5-7.31a3.18,3.18,0,0,0-3.68,3c-.16,1.9,1.22,3.8,2.56,5,1.51,1.35,5.72,2.66,6,2.76a55.22,55.22,0,0,0-1.77,7.33c-.26,1.44-.48,2.91-.67,4.37,0-.68,0-1.29,0-1.38-.31-2.38-2.31-6.82-5-7.31a3.2,3.2,0,0,0-3.69,3c-.15,1.9,1.22,3.8,2.57,5s4.92,2.4,5.86,2.71l-.21,1.69c-.32,2.71-.63,5.41-1,8.05-.14.93-.3,1.84-.47,2.76,0-.61,0-1.12,0-1.2-.31-2.39-2.31-6.82-5-7.31a3.18,3.18,0,0,0-3.68,3c-.15,1.9,1.22,3.8,2.56,5s4.58,2.28,5.7,2.65c-.2.93-.39,1.86-.62,2.75-.18.61-.3,1.2-.51,1.8l-.57,1.78c-.41,1.11-.82,2.26-1.24,3.34-.29.75-.58,1.46-.86,2.18.14-.93.39-2.75.39-2.9a12.37,12.37,0,0,0-1.66-6,4.23,4.23,0,0,0,0-.71,3.2,3.2,0,0,0-3.91-2.71c-2.61.7-4.26,5.28-4.38,7.68,0,.14.08,1.69.16,2.67-.13-.57-.26-1.12-.4-1.7-.27-1.16-.58-2.3-.9-3.53l-.54-1.78c-.17-.6-.42-1.22-.63-1.83-.52-1.41-1.11-2.81-1.74-4.21,1-.24,4.58-1.15,6-2.26s2.94-2.88,2.93-4.79a3.2,3.2,0,0,0-3.45-3.27c-2.68.29-5,4.57-5.5,6.93,0,.14-.19,1.88-.26,2.83-.38-.84-.76-1.68-1.17-2.51-1.2-2.42-2.49-4.83-3.77-7.23-.39-.74-.77-1.48-1.15-2.22.36-.08,4.63-1.07,6.23-2.3,1.43-1.1,2.94-2.89,2.93-4.79a3.19,3.19,0,0,0-3.45-3.27c-2.68.29-5,4.56-5.5,6.92,0,.18-.26,2.67-.28,3.31-.85-1.63-1.67-3.26-2.42-4.89a55.51,55.51,0,0,1-2.64-6.81c.17,0,4.63-1,6.27-2.31,1.43-1.1,3-2.89,2.93-4.79a3.19,3.19,0,0,0-3.45-3.27c-2.68.29-5,4.56-5.49,6.92,0,.16-.21,2.06-.27,3l-.15,0a41,41,0,0,1-1.38-7.21c-.15-1.34-.21-2.63-.25-3.88.85-.11,4.73-.62,6.33-1.59s3.24-2.55,3.44-4.45a3.19,3.19,0,0,0-3.07-3.62c-2.7,0-5.48,4-6.22,6.27,0,.13-.31,1.44-.5,2.4,0-.57,0-1.15,0-1.7,0-2,.13-3.9.26-5.56.08-.94.17-1.79.26-2.58.78-.53,3.9-2.74,4.86-4.31s1.71-3.76,1-5.53a3.19,3.19,0,0,0-4.4-1.8c-2.4,1.24-3,6.06-2.63,8.44,0,.2.94,3.35,1,3.33l0,0c-.11.76-.21,1.58-.31,2.48-.16,1.65-.33,3.52-.38,5.57a57.6,57.6,0,0,0,.16,6.61,42.57,42.57,0,0,0,1.22,7.31l0,.08c-.42-.67-1.67-2.49-1.79-2.62-1.57-1.82-5.69-4.42-8.17-3.36a3.19,3.19,0,0,0-1.42,4.53C649.07,382.49,651.27,383.32,653.05,383.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.41,369.86c1.94.85,6.67.74,6.68.74s-1-3.1-1.11-3.29c-1-2.17-4.32-5.76-7-5.4a3.19,3.19,0,0,0-2.56,4C647.86,367.76,649.76,369.14,651.41,369.86Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.32,370.9s.86-3.15.89-3.35c.33-2.39-.43-7.19-2.86-8.37a3.2,3.2,0,0,0-4.35,1.93c-.65,1.79.18,4,1.16,5.49C695.3,368.38,699.31,370.9,699.32,370.9Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.05,383.58c2,.29,6.23-.93,6.57-1a57,57,0,0,0,2.56,7.09c.58,1.35,1.21,2.68,1.86,4l-.79-1.14c-1.58-1.82-5.7-4.41-8.18-3.36a3.21,3.21,0,0,0-1.42,4.54c.92,1.67,3.12,2.49,4.9,2.75s5.43-.71,6.39-1l.75,1.53c1.22,2.44,2.46,4.87,3.59,7.28.4.85.77,1.71,1.13,2.56-.34-.5-.63-.92-.68-1-1.58-1.82-5.7-4.42-8.18-3.36a3.2,3.2,0,0,0-1.42,4.54c.92,1.66,3.12,2.49,4.9,2.75s5.08-.62,6.21-.93c.35.88.7,1.77,1,2.64.19.6.42,1.17.57,1.78s.34,1.2.5,1.79c.28,1.16.57,2.34.81,3.48.18.78.33,1.53.48,2.29-.38-.85-1.18-2.5-1.26-2.63-1.28-2-5-5.23-7.58-4.57a3.19,3.19,0,0,0-2.08,4.27c.65,1.79,2.7,2.94,4.42,3.47,1.89.58,6.09.05,6.61,0,.25,1.25.49,2.47.69,3.63.42,2.41.75,4.59,1,6.45h1.76c-.3-1.93-.69-4.21-1.19-6.75-.25-1.27-.54-2.63-.86-4a34.34,34.34,0,0,0,3.69-1.74c1.38,1.5,4.92,3.25,5.38,3.47-.48,1.18-1,2.33-1.43,3.41-.92,2.11-1.79,4-2.58,5.62h1.91c.66-1.48,1.39-3.16,2.14-5,.5-1.2,1-2.5,1.5-3.83.51.11,4.66.95,6.6.51,1.76-.39,3.88-1.38,4.67-3.12a3.19,3.19,0,0,0-1.77-4.41c-2.55-.86-6.46,2-7.89,4-.08.12-.86,1.46-1.34,2.31.21-.54.41-1.07.61-1.63.41-1.12.79-2.24,1.19-3.44l.54-1.79c.19-.59.32-1.24.48-1.87.35-1.46.63-3,.88-4.47,1,.35,4.46,1.57,6.26,1.44s4-.79,5.08-2.38a3.19,3.19,0,0,0-1.07-4.63c-2.4-1.24-6.7,1-8.4,2.74-.11.11-1.2,1.46-1.78,2.22.14-.91.29-1.82.4-2.75.34-2.67.59-5.39.85-8.1.08-.83.17-1.66.26-2.48.35.13,4.45,1.65,6.47,1.51,1.8-.12,4-.78,5.09-2.38a3.2,3.2,0,0,0-1.07-4.63c-2.4-1.24-6.7,1-8.41,2.74-.13.13-1.69,2.09-2.06,2.6.19-1.82.4-3.63.68-5.41a57,57,0,0,1,1.55-7.13c.16.06,4.44,1.68,6.51,1.53,1.8-.12,4.05-.78,5.09-2.38a3.2,3.2,0,0,0-1.08-4.63c-2.39-1.24-6.69,1-8.4,2.74-.11.12-1.31,1.6-1.86,2.32l-.13-.07a40.44,40.44,0,0,1,2.83-6.76c.61-1.2,1.26-2.32,1.92-3.39.77.39,4.29,2.1,6.17,2.17s4.11-.33,5.31-1.81a3.19,3.19,0,0,0-.55-4.72c-2.25-1.49-6.77.31-8.66,1.81-.1.08-1.05,1-1.73,1.72.3-.48.61-1,.91-1.43,1.13-1.7,2.27-3.18,3.29-4.49.58-.74,1.13-1.4,1.64-2,1,0,4.77-.13,6.44-.91s3.49-2.2,3.88-4.06a3.19,3.19,0,0,0-2.67-3.93c-2.68-.29-5.87,3.39-6.85,5.59-.08.19-1.07,3.32-1,3.32h.06c-.51.58-1,1.2-1.62,1.9-1,1.29-2.22,2.75-3.39,4.44a55.29,55.29,0,0,0-3.52,5.6,42.26,42.26,0,0,0-3,6.77s0,0,0,.08c0-.79,0-3,0-3.17-.31-2.39-2.32-6.82-5-7.31a3.18,3.18,0,0,0-3.68,3c-.16,1.9,1.22,3.8,2.56,5,1.51,1.35,5.72,2.66,6,2.76a55.22,55.22,0,0,0-1.77,7.33c-.26,1.44-.48,2.91-.67,4.37,0-.68,0-1.29,0-1.38-.31-2.38-2.31-6.82-5-7.31a3.2,3.2,0,0,0-3.69,3c-.15,1.9,1.22,3.8,2.57,5s4.92,2.4,5.86,2.71l-.21,1.69c-.32,2.71-.63,5.41-1,8.05-.14.93-.3,1.84-.47,2.76,0-.61,0-1.12,0-1.2-.31-2.39-2.31-6.82-5-7.31a3.18,3.18,0,0,0-3.68,3c-.15,1.9,1.22,3.8,2.56,5s4.58,2.28,5.7,2.65c-.2.93-.39,1.86-.62,2.75-.18.61-.3,1.2-.51,1.8l-.57,1.78c-.41,1.11-.82,2.26-1.24,3.34-.29.75-.58,1.46-.86,2.18.14-.93.39-2.75.39-2.9a12.37,12.37,0,0,0-1.66-6,4.23,4.23,0,0,0,0-.71,3.2,3.2,0,0,0-3.91-2.71c-2.61.7-4.26,5.28-4.38,7.68,0,.14.08,1.69.16,2.67-.13-.57-.26-1.12-.4-1.7-.27-1.16-.58-2.3-.9-3.53l-.54-1.78c-.17-.6-.42-1.22-.63-1.83-.52-1.41-1.11-2.81-1.74-4.21,1-.24,4.58-1.15,6-2.26s2.94-2.88,2.93-4.79a3.2,3.2,0,0,0-3.45-3.27c-2.68.29-5,4.57-5.5,6.93,0,.14-.19,1.88-.26,2.83-.38-.84-.76-1.68-1.17-2.51-1.2-2.42-2.49-4.83-3.77-7.23-.39-.74-.77-1.48-1.15-2.22.36-.08,4.63-1.07,6.23-2.3,1.43-1.1,2.94-2.89,2.93-4.79a3.19,3.19,0,0,0-3.45-3.27c-2.68.29-5,4.56-5.5,6.92,0,.18-.26,2.67-.28,3.31-.85-1.63-1.67-3.26-2.42-4.89a55.51,55.51,0,0,1-2.64-6.81c.17,0,4.63-1,6.27-2.31,1.43-1.1,3-2.89,2.93-4.79a3.19,3.19,0,0,0-3.45-3.27c-2.68.29-5,4.56-5.49,6.92,0,.16-.21,2.06-.27,3l-.15,0a41,41,0,0,1-1.38-7.21c-.15-1.34-.21-2.63-.25-3.88.85-.11,4.73-.62,6.33-1.59s3.24-2.55,3.44-4.45a3.19,3.19,0,0,0-3.07-3.62c-2.7,0-5.48,4-6.22,6.27,0,.13-.31,1.44-.5,2.4,0-.57,0-1.15,0-1.7,0-2,.13-3.9.26-5.56.08-.94.17-1.79.26-2.58.78-.53,3.9-2.74,4.86-4.31s1.71-3.76,1-5.53a3.19,3.19,0,0,0-4.4-1.8c-2.4,1.24-3,6.06-2.63,8.44,0,.2.94,3.35,1,3.33l0,0c-.11.76-.21,1.58-.31,2.48-.16,1.65-.33,3.52-.38,5.57a57.6,57.6,0,0,0,.16,6.61,42.57,42.57,0,0,0,1.22,7.31l0,.08c-.42-.67-1.67-2.49-1.79-2.62-1.57-1.82-5.69-4.42-8.17-3.36a3.19,3.19,0,0,0-1.42,4.53C649.07,382.49,651.27,383.32,653.05,383.58Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.94,341.44s1.25-.25,11.5-3.25a44.66,44.66,0,0,0,17.5-10.5l-3.25-20.5-20.75,3Z",
    style: {
      fill: "#052455",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.94,410.94s-3.5,7-4,13.5,3.25,8.75,4.5,7,3.25-8,3.5-10.75l.75-8.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,415.44s-1,9-1.27,13.25,5,8.25,5.74,8.51,1.5,0,2.75-3,1.26-10.25.52-12.5-2.24-5.75-2.24-5.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.94,283.69s-10.09,12-13.59,22-6.29,22.38-8.66,29a163.85,163.85,0,0,0-5,17.25s-6.5,6.5-8.25,12.25-22.25,48.25-22.25,48.25,1.25,1.75,2.25,2,3.25-1,3.25-1,36.25-47.5,38.5-51,9.35-11.6,10.1-12.85,6.4-18.65,8.4-21.15a41.31,41.31,0,0,0,3.88-6.34l1.5,1,1.75.25s7.87,15.84,9.87,22.34,7.75,42,9.25,48.5,3.5,23.5,3.5,23.5a27.44,27.44,0,0,0,2.75.75c1.25.25,4.5-.75,4.5-.75s5.75-26,6-35-1.5-29-1.5-32-4.5-44.25-6.75-49.75-9.75-15.25-9.75-15.25Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.69,236.44l-15,4.75s0,29,.25,32.75-1.75,10-.5,11.5,7.25,7.5,18.25,7.75,14-3.25,14-3.25l2.25-9.75s7.25-19.5,7.25-22.5-7.25-11.75-11.5-15.25S198.69,236.44,198.69,236.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.94,270.69a81.72,81.72,0,0,1-10,5.75l-20,10,2.25,4.75a127,127,0,0,1,14.75-1.75c6.5-.25,17.5-4.5,18.25-5.75s3.25-8,3.25-8Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.69,236.69s-10.75,29.5-11.25,33.75-4.75,15-5,16.5-7.25,16.75-7.25,16.75,7.5-23.5,8.25-28.25a18.67,18.67,0,0,0-1-9s-5.07,10.76-5.82,11.51-5.84,9.34-5.84,9.34l-8.84-16.6s9.75-17,11.75-19.75,6.25-10.25,9.25-11.75S196.69,236.69,196.69,236.69Z",
    style: {
      fill: "#052455",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.44,240.44s-7.75,32.5-7.75,37.75-.75,21.5-1.5,30.5-2.25,37.75-2.25,37.75a61.87,61.87,0,0,0,14.5.5c7-.75,19-5.5,19-5.5s-6.25-31.5-8.75-39a190.14,190.14,0,0,1-5.25-19.75c0-.75,6.75-22.75,6.75-25.75S214.19,241.19,211.44,240.44Z",
    style: {
      fill: "#052455",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.28,288.32a11,11,0,0,0-1-5.52c-1.36-2.68-2.1-3.51.08-2.92s3.46,4.86,3.46,4.86Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.35,290.12s-2.86,4.52-4.58,4.11-9.35-4.23-9.49-5.91,1.31-6.73,2.57-6.51S137.35,290.12,137.35,290.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,209.77a37.45,37.45,0,0,1,1.47,5.95,16.87,16.87,0,0,1-.68,3.63s4.09,3.64,4.32,4.55-2.27,2.27-2.27,2.27.22,9.54.22,10.22-11.13,1.14-11.13,1.14L202.3,251.16l-5.45-13.4,2.5-7.5s-7.5-4.32-4.77-10.91,8.86-10.22,15-11.13a36,36,0,0,1,12,.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.89 237.53 208.19 236.44 207.86 244.11 213.89 237.53",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.42,220.23c0,.8-.29,1.44-.66,1.44s-.66-.64-.66-1.44.3-1.43.66-1.43S220.42,219.44,220.42,220.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.22,217.92s.66-1.32,3.08-.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.73,228.5s-2.87.44-4-1.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.52,212.54s-7.49-1.82-8.86.91-.22,4.09-1.36,6.59-5.45,5.68-5.45,5.68-4.09-4.55-5.46-2.28-.91,5.68.46,6.82,5.22.45,5.22.45l-5.9,2.73s.22,3.41-5.23,4.77-12-2.27-11.13-6.81,8.4-7.27,8.4-7.27-8-9.77-1.36-17,19.54-3.86,19.54-3.86,1.82-2,7-2.5,7.5,4.77,7.5,7.73S222.52,212.54,222.52,212.54Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.86,137l-2.67-51.58-44.34,24.09,1,4,16.77,8.56L491.71,276.72l-250.44,68.1L68.14,226.66a7,7,0,0,0-7.9,11.57L236,358.2a7,7,0,0,0,4,1.22,6.73,6.73,0,0,0,1.83-.25l256.55-69.75a7,7,0,0,0,4.4-3.57l80.32-157.38Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.86,133l-2.67-51.58-43.34,28.09,16.77,8.56L490.71,272.72l-250.44,68.1L67.14,222.66a7,7,0,0,0-7.9,11.57L235,354.2a7,7,0,0,0,4,1.22,6.73,6.73,0,0,0,1.83-.25l256.55-69.75a7,7,0,0,0,4.4-3.57l80.32-157.38Z",
    style: {
      fill: "#052455",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.65,90.35,562.84,109l13.51,6.89L494.16,277,239.35,346.25l-175-119.46a2,2,0,0,0-2.78.53,2,2,0,0,0,.52,2.78l175.8,120a2,2,0,0,0,1.13.35,2.32,2.32,0,0,0,.52-.07l256.55-69.76a2,2,0,0,0,1.26-1l82.59-161.83,13.51,6.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.82,294.73,215.45,300a61,61,0,0,1-5.38,8.54c-3.3,4.37-15.15,16.56-15.15,16.56l-3.35,4.13-.39,3.62,2.72,1.05s1.36.53,2.47,1.1,4,1.09,4.89.42,3-6.1,3-6.1l.8-4.19s14.08-11.05,17.3-14.4,6-6.36,6.94-8.3.17-7.89.17-7.89Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.47,269.17,214,295.73a56.18,56.18,0,0,0,7.2,2.06c3.95.84,12.2-1.34,12.2-1.34s-1.27-22.11-2.92-30.2-6.25-14.14-9.21-15.15",
    style: {
      fill: "#052455",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 533.19,
    y1: 431.44,
    x2: 714.19,
    y2: 431.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 511.19,
    y1: 431.44,
    x2: 524.19,
    y2: 431.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.19,
    y1: 431.44,
    x2: 500.19,
    y2: 431.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.19,
    y1: 431.44,
    x2: 175.19,
    y2: 431.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.577a6bb48b788e54f42089bdfa229362.svg";
export { ForwardRef as ReactComponent };